import { Box, Menu, MenuItem } from "@mui/material";
import { clearOpenSections } from "components/app/App.slice";
import Button from "components/common/Button";
import CreatePlanButton from "components/common/CreatePlanButton";
import DialogFormation from "components/common/DialogFormation";
import Form from "components/common/Form";
import Typography from "components/common/Typography";
import { useTranslate } from "hooks/useTranslate";
import * as React from "react";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";

interface Props {
  disableInnCode?: boolean;
  sx?: any;
}

function CreateMyPlan(props: Props) {
  const translate = useTranslate();
  const { disableInnCode = false, sx } = props;
  const dispatch = useAppDispatch();
  const [createNewPlan, setCreateNewPlan] = useState(false);
  const [isTemplateType, setIsTemplateType] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openCreateMenu = Boolean(anchorEl);
  const { isAbovePropertyUser } = useAppSelector((state) => state.app.loggedInUserDetails);
  const formRef: any = React.useRef(null);

  React.useEffect(() => {
    dispatch(clearOpenSections());
  }, [dispatch]);

  const handleCreatePlanDialog = () => {
    setCreateNewPlan(false);
  };

  const formSubmit = () => formRef?.current?.submitForm();

  const getOnClickForCreatePlan = (event: React.MouseEvent<HTMLElement>) => {
    if (isAbovePropertyUser) handleOpenCreateMenu(event);
    else {
      setIsTemplateType(false);
      setCreateNewPlan(true);
    }
  };

  const handleOpenCreateMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseCreateMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <CreatePlanButton sx={sx} getOnClickForCreatePlan={getOnClickForCreatePlan} />
      <Menu
        id="create-menu"
        anchorEl={anchorEl}
        open={openCreateMenu}
        onClose={handleCloseCreateMenu}
        sx={{
          ".MuiList-root": {
            padding: "0",
            margin: "8px"
          }
        }}
      >
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setIsTemplateType(false);
            setCreateNewPlan(true);
          }}
        >
          <Box>
            <Typography variant="body2" showBold sx={{ color: tokens.Text.General.PrimaryHeadline }}>
              {translate("myplan.PropertyPlan")}
            </Typography>
            <Typography variant="label" sx={{ color: tokens.Text.General.Secondary }}>
              {translate("myplan.createPropertyPlan")}
            </Typography>
          </Box>
        </MenuItem>
        {isAbovePropertyUser && (
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              setIsTemplateType(true);
              setCreateNewPlan(true);
            }}
          >
            <Box>
              <Typography variant="body2" showBold sx={{ color: tokens.Text.General.PrimaryHeadline }}>
                {translate("myplan.TemplatePlan")}
              </Typography>
              <Typography variant="label" sx={{ color: tokens.Text.General.Secondary, whiteSpace: "normal" }}>
                {translate("myplan.createTemplatePlan")}
              </Typography>
            </Box>
          </MenuItem>
        )}
      </Menu>
      {createNewPlan && (
        <DialogFormation
          title="Create new plan"
          openDialog={createNewPlan}
          handleClose={handleCreatePlanDialog}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button variant="secondary" label="Cancel" onClick={handleCreatePlanDialog} />
              <Button variant="primary" label="Save" onClick={formSubmit} />
            </div>
          }
        >
          <div className="create-new-plan-child">
            <Form
              ref={formRef}
              handleCloseDialog={handleCreatePlanDialog}
              copyToNewPlan={false}
              disableInnCode={disableInnCode}
              isTemplateType={isTemplateType}
            />
          </div>
        </DialogFormation>
      )}
    </>
  );
}

export default CreateMyPlan;
